import type { ClientGroupListItem } from '@/common/hooks/useClientGroupList/useClientGroupList';
import { getFullName } from '@/common/utils/person';

export const getClientLabels = (
  client: Pick<
    ClientGroupListItem['clients'][0],
    'entityType' | 'entityName' | 'firstName' | 'lastName'
  >,
) => {
  const { entityType, entityName, firstName, lastName } = client;
  const fullName = getFullName(firstName, lastName);

  switch (entityType) {
    case 'powerOfAttorney':
      return {
        label: fullName,
        secondaryLabel: null,
      };
    case 'probate':
      return {
        label: fullName,
        secondaryLabel: entityName,
      };
    default:
      return {
        label: entityName ?? fullName,
        secondaryLabel: entityName && fullName ? fullName : null,
      };
  }
};
